module.exports = __webpack_public_path__ + "media/images/logo-700wlw-b3cb02cfe1a9a67fda04100f8337c174.png";